'use strict';

const _ = require('lodash');
const jQuery = require('jquery');

const Mediator = require('./../../../core/mediator');

const ContentManager = require('./../component/ContentManager');
const SaveManager = require('./../component/SaveManager');

const AddContent = require('./addContent');
const Loader = require('./../../../services/loader');
const ImageCrop = require('./../service/imageCrop');
const Uploader = require('./../service/uploader');
const PluginUpload = require('./../plugin/upload');
const ImagePlaceholder = require('./../service/imagePlaceholder');
const TextPlaceholder = require('./../service/textPlaceholder');

const getImageContent = (content) => {
  let imageContent = content.getProperties('is_image') ? content : null;
  if (!imageContent) {
    let $childrenImage = content.$.find('.bb-content.media-image');

    if ($childrenImage.length) {
      imageContent = ContentManager.getContentByNode($childrenImage);
    }
  }

  return imageContent;
};

module.exports.afterDrop = (content) => {
  let imageContent = getImageContent(content);

  if (imageContent) {
    ImagePlaceholder.apply(imageContent);
  }
};

module.exports.afterSubmitParameters = (content) => {
  let imageContent = getImageContent(content);

  if (imageContent) {
    TextPlaceholder.globalApply();
    ImagePlaceholder.apply(imageContent);
    ImageCrop.checkCrop();
    ImageCrop.refresh(imageContent);
  }
};

module.exports.afterAdd = (content) => {
  let imageContent = getImageContent(content);

  if (imageContent) {
    ImagePlaceholder.apply(imageContent);
    AddContent.empty(imageContent);
  }
};

module.exports.beforeMobileAdd = (content) => {
  if (content && content.definition.properties.is_image) {
    AddContent.mobile.before.hidePanels(content);
  }
};

module.exports.afterMobileAdd = (content) => {
  let imageContent = getImageContent(content);

  if (imageContent) {
    ImagePlaceholder.apply(content);
    AddContent.mobile.after.showMenu(imageContent);
  }
};

module.exports.afterMobileDrop = (content) => {
  let imageContent = getImageContent(content);

  if (imageContent) {
    ImagePlaceholder.apply(imageContent);
  }
};

module.exports.initGlobalDndEvent = () => {
  let $body = jQuery('body');

  $body.on('dragenter', '.bb-content.media-image', function(event) {
    let content = ContentManager.getContentByNode(jQuery(event.currentTarget));

    if (-1 === _.indexOf(content.getForbiddenPlugins(), 'upload')) {
      event.preventDefault();
    }
  });

  $body.on('dragover', '.bb-content.media-image', function(event) {
    let content = ContentManager.getContentByNode(jQuery(event.currentTarget));

    if (-1 === _.indexOf(content.getForbiddenPlugins(), 'upload')) {
      event.preventDefault();
      jQuery(this).addClass('cloud-placeholder-droppable');
    }
  });

  $body.on('dragleave', '.bb-content.media-image', function(event) {
    let content = ContentManager.getContentByNode(jQuery(event.currentTarget));

    if (-1 === _.indexOf(content.getForbiddenPlugins(), 'upload')) {
      jQuery('.cloud-placeholder-droppable').removeClass('cloud-placeholder-droppable');
    }
  });

  $body.on('drop dragdrop', '.bb-content.media-image', function(event) {
    let content = ContentManager.getContentByNode(jQuery(event.currentTarget));

    if (-1 === _.indexOf(content.getForbiddenPlugins(), 'upload')) {
      event.preventDefault();

      let dt = event.dataTransfer || (event.originalEvent && event.originalEvent.dataTransfer);
      let files = event.target.files || (dt && dt.files);
      if (files.length === 1) {
        Loader.start(content.$);
        Uploader.imageIsValid(files[0], true).done(function() {
          Uploader.upload(files[0], {content}).done(function(response) {
            PluginUpload.updateFileOfMedia(content, response).done(() => {
              SaveManager.save().done(() => {
                content.refresh().done(() => {
                  Mediator.publish('after:upload', content);
                  Loader.stop(content.$);
                });
              });
            });
          });
        }).fail(function() {
          Loader.stop(content.$);
        });
      } else {
        jQuery('.cloud-placeholder-droppable').removeClass('cloud-placeholder-droppable');
      }
    }
  });
};

/**
 * After upload image.
 * @param {object} content
 */
module.exports.afterUpload = (content) => {
  let $figure = content.$;
  let $img = content.$.find('img');

  $img.on('load', function() {
    setTimeout(function() {
      let left = ($figure.width() - $img.width()) / 2 / $figure.width() * 100;
      let positionCenter;
      let ratio = $img.height() / $figure.outerWidth() * 100;

      $img.attr('style', 'left: ' + left + '%');
      positionCenter = {'top': 0, 'left': left};
      $figure.attr('style', 'padding-top: ' + ratio + '%');

      content.addParameter('position', positionCenter);
      content.addParameter('ratio', ratio + '');
      content.addParameter('focus', {'top': 50, 'left': 50});

      SaveManager.save().done(() => {
        content.refresh();
      });
    }, 0);
  });
};
